import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ListingContext from '../../providers/Listing/Listing.context';
import DealContext from '../../providers/Deal/Deal.context';
import SettingsIcon from 'icons/Settings.icon';
import { DEAL_STATUS_COLOR, DEAL_STATUS_LABEL } from 'data/dealStatus';
import { useTranslation } from 'react-i18next';

import './ManageDealStatusButton.styles.scss';

type ManageDealStatusButtonProps = {
  className?: string;
};

const ManageDealStatusButton: React.FC<ManageDealStatusButtonProps> = (
  props,
) => {
  const { className } = props;

  const { canManageDeal } = useContext(ListingContext);
  const {
    dealRoom: { stage },
    openDealStatusDrawer,
  } = useContext(DealContext);

  const classes = classNames(
    'manage-deal-status-button',
    DEAL_STATUS_COLOR[stage],
    className,
  );

  const { t } = useTranslation();

  return (
    <Button
      disabled={!canManageDeal}
      icon={SettingsIcon}
      iconPosition="right"
      className={classes}
      onClick={openDealStatusDrawer}
    >
      {t(DEAL_STATUS_LABEL[stage])}
    </Button>
  );
};

export default ManageDealStatusButton;
